/**
 * Bootstrap
 */

import {
    // Collapse,
    // Dropdown,
    // Alert,
    // Button,
    // Carousel,
    Modal,
    // Offcanvas,
    // Popover,
    // ScrollSpy,
    // Tab,
    // Toast,
    // Tooltip,
} from 'bootstrap';

window.Modal = Modal;

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/**
 * GSAP
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin.js";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, MorphSVGPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.MorphSVGPlugin = MorphSVGPlugin;

/**
 * Animations
 */

import animations from "./js/animations.js";
animations();

/**
 * Header
 */

import "./js/header.js";

/**
 * Contact modal
 */

import "./js/contact-modal.js";

/**
 * Blocks
 */

import "./js/block-hero.js";
import "./js/block-cards.js";
import "./js/block-info.js";
import "./js/block-slider-grid.js";
import "./js/block-map.js";

document.addEventListener('DOMContentLoaded', () => {
    const anchors = document.querySelectorAll('a[href*="#"]')
    if (!anchors.length) return;
    anchors.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            const hash = anchor.hash;
            if (!hash || hash.length < 2) return;

            // Salta i link che puntano a un'altra pagina
            if (anchor.pathname !== window.location.pathname || anchor.hostname !== window.location.hostname) return;

            const target = document.querySelector(hash);
            if (!target) return;

            e.preventDefault();
            const headerHeight = document.querySelector(".header")?.offsetHeight || 0;
            gsap.to(window, {
                duration: 1.2,
                ease: "power2.inOut",
                scrollTo: { y: target, offsetY: headerHeight },
            });
        })
    })
})